import ContactFormHeader from
  '../container/ContactFormHeader/ContactFormHeader';
import ContactForm from '../container/ContactForm/ContactForm';
import Head from 'next/head';

const Contact = () => (
  <div>
    <Head>
      <title>Shaking Crab | Contact</title>
    </Head>
    <ContactFormHeader />
    <ContactForm />
  </div>
);

export default Contact;
